import React, { useEffect, useState } from 'react';
import {
  Snackbar,
  Alert,
  AlertColor,
} from '@mui/material';

interface CustomSnackbarProps {
  open: boolean;
  message: string;
  severity?: AlertColor;
  autoHideDuration?: number;
  onClose: () => void;
  vertical?: 'top' | 'bottom';
  horizontal?: 'left' | 'center' | 'right';
}

export default function CustomSnackbar({
  open,
  message,
  severity = 'success',
  autoHideDuration = 6000,
  onClose,
  vertical = 'top',
  horizontal = 'right',
}: CustomSnackbarProps) {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsOpen(false);
    onClose();
  };

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{ width: '100%', color: 'white' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
